import React, { Component } from 'react';
import { oneOf, arrayOf, bool, func, number, shape, string } from 'prop-types';
import Cell from 'ps-components/Table/Cell/Cell';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import Row from 'ps-components/Table/Row/Row';
import './DataCutRow.scss';

const OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

class DataCutRow extends Component {
  static propTypes = {
    updateDataCutSelection: func,
    getDataCutPriority: func.isRequired,
    getDataCutName: func.isRequired,
    getDataCutId: func.isRequired,
    isDataCutSelected: func.isRequired,
    dataCut: shape({
      currency: oneOf([
        string,
        shape({
          code: string
        })
      ]),
      id: string,
      name: string,
      survey: shape({
        code: string,
        id: string,
        name: string
      })
    }),
    deleteDataCutFromRule: func,
    selectedRuleConnection: arrayOf(
      shape({
        dataCut: shape({
          currency: shape({
            code: string
          }),
          id: string,
          name: string,
          survey: shape({
            code: string,
            id: string,
            name: string
          })
        }),
        id: string,
        priority: number
      })
    ),
    updateDataCutPriority: func
  };

  constructor(props) {
    super(props);
    this.state = { ids: [] };
  }

  componentDidMount() {
    this.setState({ ids: this.getIds() });
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedRuleConnection } = this.props;

    if (selectedRuleConnection !== prevProps.selectedRuleConnection) {
      this.setState({ ids: this.getIds() });
    }
  }

  addOrRemoveDataCut = () => {
    const { updateDataCutSelection, dataCut, deleteDataCutFromRule } = this.props;
    const { ids } = this.state;

    ids.includes(dataCut.id) ? deleteDataCutFromRule(dataCut) : updateDataCutSelection(dataCut, 1);
  };

  getIds() {
    const { selectedRuleConnection } = this.props;
    return selectedRuleConnection.map(connection => connection.dataCut.id);
  }

  renderPriorityCell(isSelected) {
    if (!isSelected) return;

    const { dataCut, getDataCutPriority, getDataCutId } = this.props;

    return (
      <select
        className="datacut__priority-select"
        key={getDataCutId(dataCut)}
        onChange={e => this.updateDataCutPriority(e)}
        defaultValue={getDataCutPriority(dataCut)}
      >
        {this.renderPriorityOptions()}
      </select>
    );
  }

  renderPriorityOptions() {
    return OPTIONS.map(option => <option key={option}>{option}</option>);
  }

  updateDataCutPriority = e => {
    const { updateDataCutPriority, dataCut } = this.props;
    const value = parseInt(e.target.value);
    updateDataCutPriority(dataCut, value);
  };

  render() {
    const { dataCut, getDataCutName, getDataCutCurrency, isDataCutSelected } = this.props;
    const { ids } = this.state;
    const isSelected = isDataCutSelected(dataCut);
    return (
      <Row className="datacut">
        <Cell className="datacut__checkbox">
          <CheckboxInput checked={isSelected} className="datacut__checkbox-input" onClick={this.addOrRemoveDataCut} />
        </Cell>
        <Cell className="datacut__data">{getDataCutName(dataCut)} </Cell>
        <Cell className="datacut__data">{getDataCutCurrency(dataCut)}</Cell>
        <Cell className="datacut__priority">{this.renderPriorityCell(isSelected)}</Cell>
      </Row>
    );
  }
}

export default DataCutRow;
